type Coords = {
  lat: number;
  lon: number;
};

const fractionDigits = 12;

export function encodeCoords({ lat, lon }: Coords): string {
  return `${lat.toFixed(fractionDigits)},${lon.toFixed(fractionDigits)}`;
}
